import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { LeadsAction } from "stores/Leads/LeadsAction";

const mapStateToProps = (state) => {
    return {
        leadsDataList: state.LeadsData.leadsDataList,
        isLoading: state.LeadsData.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
   
    getLeadsAction: LeadsAction.getLeadsAction,
   
}, dispatch);

const CustomerDataStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default CustomerDataStore;
